import Icon from "@react-native-vector-icons/material-design-icons/static";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import MarkdownRenderer from "../MarkdownRenderer";

type Props = {
	features: string[];
	appFont?: string;
};

const FeaturesSection = ({ features, appFont }: Props) => {
	const theme = useAppTheme();
	return (
		<Box paddingHorizontal={0} gap={8} width="100%">
			{features.map((item) => (
				<Box
					display="flex"
					flexDirection="row"
					alignItems="center"
					key={item}
					gap={8}
				>
					<Box
						borderWidth={1}
						borderColor={theme.colors.outlineVariant}
						borderRadius={999}
						padding={6}
					>
						<Icon size={16} color={theme.colors.primary} name="check-bold" />
					</Box>
					<Box flex={1}>
						<MarkdownRenderer
							variant="explanation"
							text={item}
							appFont={appFont}
						/>
					</Box>
				</Box>
			))}
		</Box>
	);
};

export default FeaturesSection;
